import { RegulationDocument } from 'components/common-form/sidePanel/docToolbar/regulatory/model';
import { useAppSelector } from 'hooks/useAppSelector';
import { createSelector } from 'reselect';
import type { AppState } from 'state/state.model';
import { WorkspaceType } from 'state/workspaces/model';

import { RawDocuments } from './RawDocuments';
import { getQuoteRegulationInfosSelector, asDocuments } from './selector';

const getDocuments: (state: AppState, workspaceType: WorkspaceType, tabId: string) => RegulationDocument[] =
  createSelector([getQuoteRegulationInfosSelector], regulationInfos => {
    return asDocuments(regulationInfos?.productGovernanceDocumentation ?? []);
  });

const getDocumentHasErrors: (state: AppState, workspaceType: WorkspaceType, tabId: string) => boolean = createSelector(
  [getQuoteRegulationInfosSelector],
  regulationInfos => {
    return (
      (regulationInfos?.productGovernanceDocumentationError?.length ?? 0) > 0 ||
      (regulationInfos?.productGovernanceDocumentationTimeout ?? false)
    );
  },
);

export function ProductGovernanceDocumentsLegacy({
  tabId,
  workspaceType,
  className,
}: {
  tabId: string;
  workspaceType: WorkspaceType;
  className?: string;
}) {
  const documents = useAppSelector(state => getDocuments(state, workspaceType, tabId));
  const hasErrors = useAppSelector(state => getDocumentHasErrors(state, workspaceType, tabId));

  return (
    <RawDocuments
      event="Download target market language"
      documents={documents}
      hasErrors={hasErrors}
      labelKey="form.buttons.ProductGovernanceDocuments"
      e2e="download-pg-doc"
      className={className}
    />
  );
}
